export function toggleBio() {
    const toggleBioBtn = $(".toggle-bio");
    toggleBioBtn.on("click", function () {
        console.log("click");
        let $this = $(this);
        let bio = $this.closest(".team-member").find(".bio");
        if (bio.hasClass("expanded")) {
            $this.find("span").text($this.data("default-text"));
        } else {
            $this.find("span").text($this.data("alt-text"));
        }
        bio.toggleClass("expanded");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/toggleBio.js